import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { filter, Subscription } from 'rxjs';
import { ClinicPub } from '../../../core/models/clinic-pub.model';
import { clinicFormConfig } from '../../config/clinic-form.config';
import { ClinicService } from '../../../../services/clinic/clinic.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { CoreService } from '../../../core/core.service';
import { HospitalService } from '../../../../services/hospital/hospital.service';
import { Clinic } from '../../../core/models/clinic.model';

@Component({
  selector: 'app-clinic-form-dialog',
  templateUrl: './clinic-form-dialog.component.html',
  styleUrl: './clinic-form-dialog.component.scss',
})
export class ClinicFormDialogComponent {
  subscriptions: Subscription[] = [];
  @ViewChild('eoForm', { static: false }) eoForm?: EoFormComponent;

  clinic?: ClinicPub;
  hospitalId?: string | null;
  visible = false;
  formConfig = [...clinicFormConfig];

  @Output() success = new EventEmitter();

  constructor(
    private clinicService: ClinicService,
    private coreService: CoreService,
  ) {}

  ngOnInit(): void {
    this.subscriptions = [
      this.getClinicSaveSuccessSub$(),
      this.getClinicUpdateSuccessSub$(),
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.clinic) return;

    let clinicToStore = {
      id: this.clinic?.id ?? null,
      clinicCode: $event.clinic.clinicCode ?? this.clinic?.clinicCode ?? null,
      hospitalID: $event.clinic.hospitalID,
      clinicName: $event.clinic.clinicName,
      clinicFirstPhone: $event.clinic.clinicFirstPhone,
      clinicSecondPhone: $event.clinic.clinicSecondPhone,
      userID: $event.clinic.userID
    };

    clinicToStore.id
      ? this.clinicService.updateClinic(clinicToStore as Clinic).subscribe()
      : this.clinicService.saveClinic(clinicToStore).subscribe();
  }

  onSubmitSuccess(): void {
    this.clinicService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess('Η κλινική αποθηκεύτηκε με επιτυχία');
  }

  setFcValue(formControlName: string, value: any) {
    return this.eoForm?.setValue('clinic', formControlName, value);
  }

  getFormConfig() {
    return this.formConfig;
  }

  getHeader(): string {
    return this.clinic?.id
      ? `Επεξεργασία Κλινικής (${this.clinic.clinicCode})`
      : 'Νέα Κλινική';
  }

  initForm() {
    this.eoForm?.form.reset();
    this.eoForm?.form.enable();

    if (this.clinic) {
      this.hospitalId = this.clinic.hospitalID;
      this.setFcValue('hospitalID', this.clinic.hospitalID);
      this.setFcValue('clinicName', this.clinic.clinicName);
      this.setFcValue('clinicCode', this.clinic.clinicCode);
      this.setFcValue('userID',this.clinic.userID);
      this.setFcValue('clinicFirstPhone', this.clinic.clinicFirstPhone);
      this.setFcValue('clinicSecondPhone', this.clinic.clinicSecondPhone);
    }
  }

  getClinicSaveSuccessSub$() {
    return this.clinicService.clinicSaveCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  getClinicUpdateSuccessSub$() {
    return this.clinicService.clinicUpdateCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  isSubmitLoading(): boolean {
    let cSaveStatus =
      this.clinicService.clinicSaveCallHandler?.status$?.getValue();
    if (cSaveStatus === STATUS.loading) return true;

    let cUpdStatus =
      this.clinicService.clinicUpdateCallHandler?.status$?.getValue();
    if (cUpdStatus === STATUS.loading) return true;

    return false;
  }

  show(clinic?: ClinicPub): void {
    this.clinic = clinic;
    this.initForm();
    this.visible = true;
  }

  onHospitalChange($event: any) {
    this.hospitalId = $event.value || null; // Set hospitalId to selected hospital ID
  }
}
